import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as globals from "app/resources/globals";

import { EntregaItemComp } from "./item";
import { EntregaItem, obtenerItems, InfoDireccion, obtenerInfoDireccion } from "./model";
import { realizarEntrega, puedeRealizarEntrega } from "./logic";

interface Props {
    state: models.ViajeAppIniciado;
    onChange: (x: models.ViajeAppIniciado) => void;
    idDireccionDestino: number;
}

class InfoComp extends React.PureComponent<{ value: InfoDireccion }> {
    render() {
        const x = this.props.value;
        return (
            <kea.Panel title="Destino" style="primary">
                <label>Dirección:</label>{" "}{x.Descripcion}
                <br />
                <label>Cliente: </label>{" "}{x.NombreCliente}
                <br />
                <label>Teléfono: </label>{" "}
                {
                    x.TelefonoCliente &&
                    <a href={"tel:" + x.TelefonoCliente}> <i className={fa("phone")} /> {"  "} {x.TelefonoCliente} {"  "} Llamar</a>
                }
            </kea.Panel>
        )
    }
}

const RealizarButton = kea.defaultProps(kea.Button, { children: "Realizar entrega", style: "success", iconClass: fa("plus") });

/**Listado de las entregas de un destino */
class ListEntregasCompNoRx extends React.PureComponent<Props> {
    state = (props: Props) => props.state;
    idDireccion = (props: Props) => props.idDireccionDestino;

    items = createSelectorRx(this.state, this.idDireccion, (state, idDireccion) => obtenerItems(state, idDireccion));
    info = createSelectorRx(this.state, this.idDireccion, (state, idDireccion) => obtenerInfoDireccion(state, idDireccion));

    onRegresar = () => {
        history.go("../");
    }

    onAgregar = async () => {
        const old = this.props.state;
        const idDireccion = this.props.idDireccionDestino;
        const validacion = puedeRealizarEntrega(old, idDireccion);

        if (validacion != true) {
            switch (validacion) {
                case "noHayGuiasPendientes":
                    await kea.message("No hay guias pendientes", "No se puede agregar otra entrega ya que ya se entregaron/rechazaron todas las guias para este destino", "warning");
                    break;
                default: assertUnreachable(validacion);
            }
            return;
        }
        if (await kea.yesno("Realizar entrega", "¿Agregar nueva entrega realizada?")) {
            const next = realizarEntrega(old, idDireccion);
            this.props.onChange(next);
        }
    }

    render() {
        const items = this.items(this.props);
        const info = this.info(this.props);
        return (
            <div>
                <kea.Title titulo={
                    <span>
                        Entregas en
                        <b>{" "}{info.DescripcionCorta}</b>
                    </span>
                } onRegresar={this.onRegresar}  >
                    <RealizarButton onClick={this.onAgregar} />
                </kea.Title>
                <InfoComp value={info} />
                {items.length == 0 &&
                    <div className="alert alert-primary">
                        <label>Sin entregas</label>
                        <br />
                        Este destino aún no tiene ninguna entrega realizada
                    </div>
                }
                {items.map(x => <EntregaItemComp key={x.ClaveUnica} value={x} />)}
            </div>
        )
    }
}

export const ListEntregasComp = componentToRx(ListEntregasCompNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entregas/listmem.tsx